import React, { useContext, useState } from 'react'
import css from './AnuncioForm.module.css'
import { InputText } from 'primereact/inputtext'
import { UserContext } from '../context/UserContext'
import { Col, Row } from 'react-bootstrap'
import { useFormik } from 'formik'
import { Button } from 'primereact/button'
import { Checkbox } from 'primereact/checkbox'
import { linkApi } from '../config'

export default function DadosEasyData() {
    const { user } = useContext(UserContext)
    const [dadosAnuncio, setDadosAnuncio] = useState([])

    const formik = useFormik({
        initialValues: {
            idCarro: '',
            easymanager: false,
        },
        validate: (data) => {
            let errors = {}

            if (!data.idCarro) {
                errors.value = 'ID Carro is required.'
            }

            return errors
        },
        onSubmit: (values) => {
            handleClick(values)
            formik.resetForm()
        },
    })

    async function handleClick(values) {
        const options = {
            method: 'GET',
            headers: {
                authorization: 'Bearer ' + user.token,
            },
        }
        // console.log('values', values)
        const res = await fetch(
            `${linkApi}/v1/cars/easydata/` +
                values.idCarro +
                '/?easymanager=' +
                values.easymanager,
            options
        )
            .then((response) => response.json())
            .catch((err) => console.error(err))

        setDadosAnuncio(res)
    }

    return (
        <div className={css.atividadeCard}>
            <div style={{ marginTop: '40px', marginBottom: '40px' }}>
                <span className={css.title}> Dados no EasyData</span>
            </div>
            <div
                className="flex flex-column gap-2"
                style={{ display: 'flex', marginBottom: '50px' }}
            >
                <span className={css.title} htmlFor="anuncio">
                    ID do Carro
                </span>
                {/* <InputText id="anuncio" onChange={(e) => handleClick(e)} /> */}
                <form
                    onSubmit={formik.handleSubmit}
                    className="flex flex-column gap-2"
                >
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div
                            className="p-float-label"
                            style={{
                                marginRight: '30px',
                                marginBottom: '30px',
                            }}
                        >
                            <InputText
                                id="idCarro"
                                name="idCarro"
                                value={formik.values.idCarro}
                                onChange={(e) => {
                                    formik.setFieldValue(
                                        'idCarro',
                                        e.target.value
                                    )
                                }}
                            />
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox
                                inputId="easymanager"
                                checked={formik.values.easymanager}
                                onChange={(e) => {
                                    formik.setFieldValue(
                                        'easymanager',
                                        e.checked
                                    )
                                }}
                            />
                            <label htmlFor="easymanager" className="ml-2">
                                EasyManager
                            </label>
                        </div>
                    </div>
                    <Button type="submit" label="Submit" />
                </form>
            </div>
            <Row>
                {Object.keys(dadosAnuncio).map((item, index) => (
                    <Col key={index} lg={3} style={{ marginBottom: '20px' }}>
                        <span style={{ fontWeight: '500' }}>
                            {item} : <br></br>
                        </span>
                        <span>{dadosAnuncio[item]}</span>
                    </Col>
                ))}
            </Row>
        </div>
    )
}
